import script from "./ProductFamilySpot.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductFamilySpot.vue?vue&type=script&lang=ts&setup=true"

import "./ProductFamilySpot.vue?vue&type=style&index=0&id=6e4f104c&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e4f104c"]])

export default __exports__